export interface EssenceIllustrationModel {
  readonly latinName: string;
  readonly frenchName: string | null;
  readonly imageUrl: string | null;
}

/**
 * Maps a raw espece (species) database record to an EssenceIllustrationModel.
 * Falls back gracefully when fields are missing.
 */
export function toEssenceIllustrationModel(espece: {
  readonly name?: string | null;
  readonly nom_fr?: string | null;
  readonly img_url?: string | null;
}): EssenceIllustrationModel {
  return {
    latinName: espece.name ?? 'Essence',
    frenchName: espece.nom_fr ?? null,
    imageUrl: espece.img_url ?? null,
  };
}
